import { Link, useLocation } from "react-router-dom";
import { CalendarCheck } from "lucide-react";

const HIDDEN_PREFIXES = ["/admin", "/book", "/payment", "/login", "/register", "/admin-login", "/account", "/contract", "/receipt"];

export default function StickyBookBar() {
  const { pathname } = useLocation();
  if (HIDDEN_PREFIXES.some((p) => pathname.startsWith(p))) return null;
  return (
    <div data-testid="sticky-book-bar" className="md:hidden fixed bottom-0 inset-x-0 z-40 glass border-t border-primary/15 px-5 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))]">
      <Link data-testid="sticky-book-now-link" to="/fleet" className="flex items-center justify-center gap-2 w-full h-12 rounded-full bg-primary text-primary-foreground font-ui font-medium text-[15px] shadow-[0_8px_24px_rgba(199,30,46,0.35)] active:scale-95 transition-transform duration-150">
        <CalendarCheck size={16} /> Book Your Vehicle
      </Link>
    </div>
  );
}
